import { render, staticRenderFns } from "./ExtractHistoryTable.vue?vue&type=template&id=591812fc&scoped=true"
import script from "./ExtractHistoryTable.vue?vue&type=script&lang=js"
export * from "./ExtractHistoryTable.vue?vue&type=script&lang=js"
import style0 from "./ExtractHistoryTable.vue?vue&type=style&index=0&id=591812fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591812fc",
  null
  
)

export default component.exports